import { useInView } from 'react-intersection-observer';

/**
 * Hook to track section visibility using Intersection Observer
 * @param {Object} options - IntersectionObserver options
 * @param {number} options.threshold - Visibility threshold (0 to 1)
 * @param {boolean} options.triggerOnce - Whether to trigger only once
 * @returns {Array} - [ref, inView] tuple
 */
const useSectionVisibility = (options = {}) => {
  const defaultOptions = {
    threshold: 0.1,
    triggerOnce: false,
    ...options
  };

  const [ref, inView] = useInView(defaultOptions);
  return [ref, inView];
};

export default useSectionVisibility; 